var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBlog(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    t: 1693223820936,
    className: "icon",
    viewBox: "0 0 1024 1024",
    xmlns: "http://www.w3.org/2000/svg",
    "p-id": 4834,
    width: 300,
    height: 300,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M464.64 128.32a16.224 16.224 0 0 0-16.64 16.32V208c0 8.96 7.04 16 16 16v0.64c199.36 7.68 359.68 168 367.36 367.36H832c0 8.96 7.04 16 16 16h63.36c9.28 0 16.64-7.68 16.32-16.64-8.64-251.52-211.52-454.4-463.04-463.04z m0 160a16.448 16.448 0 0 0-16.64 16.32v63.36c0 8.96 7.04 16 16 16v0.96c111.04 7.36 199.68 96 207.04 207.04H672c0 8.96 7.04 16 16 16h63.36c8.96 0 16.64-7.68 16.32-16.64-8.64-163.2-139.84-294.4-303.04-303.04zM176 320c-8.96 0-16 7.04-16 16v352c0 114.56 93.44 208 208 208s208-93.44 208-208-93.44-208-208-208c-8.96 0-16 7.04-16 16v96c0 8.96 7.04 16 16 16a80 80 0 0 1 0 160A80 80 0 0 1 288 688v-352c0-8.96-7.04-16-16-16h-96z",
    "p-id": 4835
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBlog);
export default __webpack_public_path__ + "static/media/blog.02dd263dd237861e2edc9191e50646e7.svg";
export { ForwardRef as ReactComponent };